module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "english"
  }, [_c('viewer', {
    attrs: {
      "images": _vm.urls
    }
  }, [_vm._l((_vm.urls), function(a, i) {
    return [(i <= 4) ? _c('img', {
      staticClass: "hj-image-lazy",
      attrs: {
        "src": a
      }
    }) : _vm._e()]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-934efe58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advHtml/english.vue
// module id = 526
// module chunks = 2